export type FaqItem = { q: string; a: string };

/** SSS içeriği — hem arayüz hem FAQPage JSON-LD için tek kaynak (UTF-8) */
export const faqs: FaqItem[] = [
  {
    q: 'Acil kombi servisi ne kadar sürede gelir?',
    a: 'Servis yoğunluğuna bağlı olarak acil kombi servis ekiplerimiz genellikle aynı gün içerisinde adresinize ulaşmaktadır. Servis kaydınız alındıktan sonra size en yakın mobil bölge ekibimiz 30 dakikada kapınızda olur.',
  },
  {
    q: 'Kombi anakart arızası nasıl anlaşılır?',
    a: 'Kombi anakart arızasının en belirgin belirtileri şunlardır: ekranda sürekli hata kodu görünmesi, kombinin hiç çalışmaması veya rastgele kapanması, ısınma ya da sıcak su üretememesi, fan veya pompanın çalışmaması. Bu belirtilerden birini yaşıyorsanız anakart arızası olasılığı yüksektir; uzman teşhisi için bizi arayın.',
  },
  {
    q: 'Kombi anakartı tamir mi edilir, yoksa değiştirilir mi?',
    a: 'Anakart durumuna göre değerlendirilir. Yanmış kondansatör, sigorta veya röle gibi küçük komponent arızalarında kart tamir edilebilir. Ancak ana işlemci veya kritik devre hasarlarında kart değişimi daha güvenilir ve uzun vadeli çözümdür. Ekibimiz yerinde teşhis yaparak en ekonomik seçeneği size sunar.',
  },
  {
    q: 'Kombi anakart tamiri ne kadar sürer?',
    a: 'Basit komponent değişimlerinde tamir aynı gün tamamlanabilir. Kart değişimi gerekiyorsa cihaz markasına ve modeline göre yedek parça temin süresi 1–3 iş günü olabilir. Stokta bulunan markalar için genellikle aynı gün çözüm sağlanmaktadır.',
  },
  {
    q: 'Kombi bakımı ne sıklıkla yapılmalıdır?',
    a: 'Uzmanlar, kombi bakımının yılda en az bir kez, özellikle kış sezonu başlamadan önce (Ekim–Kasım aylarında) yapılmasını önermektedir. Düzenli bakım, kombinin yoğun kullanıldığı dönemlerde sorunsuz çalışmasını sağlar.',
  },
  {
    q: 'Kombi tamiri ne kadar sürer?',
    a: 'Çoğu kombi arızası uzman ekiplerimizin hızlı müdahalesi sayesinde aynı gün içerisinde giderilebilmektedir. Elektronik kart, fan motoru, eşanjör veya gaz valfi gibi parça değişimi gerektiren durumlarda tamir süresi kullanılan yedek parçanın temin süresine göre uzayabilir.',
  },
  {
    q: 'Yetkili servis ile özel servis arasındaki fark nedir?',
    a: 'Yetkili servisler garanti kapsamındaki cihazlar için tercih edilir. Özel servisler ise garanti süresi bitmiş cihazlarda daha hızlı ve ekonomik çözümler sunar. Kombi Kurumsal Servis, özel servis alanında profesyonel kombi tamiri ve bakımı ile faaliyet göstermektedir.',
  },
  {
    q: 'Hangi kombi markalarına servis veriyorsunuz?',
    a: 'ECA, Demirdöküm, Airfel, Ariston, Baymak, Vaillant, Bosch, Protherm, Sanica, Daikin ve daha pek çok marka dahil olmak üzere tüm kombi markalarına teknik servis hizmeti sunmaktayız.',
  },
  {
    q: 'Kombi parçalarında garanti var mı?',
    a: 'Evet. Kombi tamiri ve bakım sürecinde kullanılan tüm yedek parçalarımız 1 yıl garantilidir. Parçadan kaynaklanan herhangi bir sorun yaşandığında bizi aramanız yeterlidir.',
  },
  {
    q: 'Kombi servis ücreti önceden belli oluyor mu?',
    a: 'Evet, işe başlamadan önce yapılacak kombi tamiri ve bakım işlemlerini ve maliyeti net olarak belirtiyoruz. Sürpriz ücret veya gizli maliyet uygulamamamız temel prensiplerimizden biridir.',
  },
];
